import React, { useState, useEffect, useRef } from "react";
import "./notificationpopup.css";

const NotificationPopup = () => {
  const [showPopup, setShowPopup] = useState(false); 
  const [showPlus, setShowPlus] = useState(true);
  const [data, setData] = useState(null);  
  const clickSoundRef = useRef(null);

  // Fully preload the sound when component mounts
  useEffect(() => {
    const audio = new Audio("/dingSound.mp3");
    audio.preload = "auto";

    // Force the browser to load & decode the file
    audio.addEventListener("canplaythrough", () => {
      clickSoundRef.current = audio;
    });

    audio.load(); 
  }, []);

  const playSound = () => {
    if (clickSoundRef.current) {
      // cloneNode ensures instant replay without waiting
      const sound = clickSoundRef.current.cloneNode(true);
      sound.play().catch(() => {
        console.log("Playback blocked by browser. Needs user interaction first.");
      });
    }
  };

  const openPopup = () => {
    setShowPopup(true);
    setShowPlus(false);
    playSound(); 
  };

  const closePopup = () => {
    setShowPopup(false);
    setShowPlus(true);
  };


    useEffect(() => {
      const loadData = async () => {
        try {
          const res = await fetch("/data.json");
          if (!res.ok) {
            throw new Error("Failed to fetch data.json");
          }
          const dataJson = await res.json();
          setData(dataJson);
        } catch (err) {
          console.error("Failed to load data.json", err);
        }
      };
      loadData();
    }, []);

    const edutechLink = data?.['Edutech-link'] || '#';

  return (
    <>
      {/* POPUP */}
      {showPopup && (
        <div
          className="popUp"
          style={{ transform: showPopup ? "translateY(0)" : "translateY(120%)" }}
        >
          <button className="close" onClick={closePopup}>
            <i className="fa fa-times"></i>
          </button>
          <div className="new">
            <span>HELLO!</span>
          </div>
          <h2>
            To check the Edutech platform click the button below or go to services
            tab and then select edutech option
          </h2>
          <a
            href={edutechLink}
            target="_blank"
            rel="noopener noreferrer"
            className="button"
          >
            Visit
          </a>
        </div>
      )}

      {/* PLUS BUTTON */}
      {showPlus && (
        <div className="plus" onClick={openPopup}>
          <span>
            Click <i className="fa fa-plus"></i>
          </span>
        </div>
      )}
    </>
  );
};

export default NotificationPopup;
